<template>
  <div style="text-align: center;">
      <span class="info">{{status.info}}</span>

      <h3> Step 4: Invoices Updated in CargoSprint </h3>
      <p class="p-h3"> Following Invoices have been updated </p>

      <!-- Warning banner for unmatched/failed invoices -->
      <div v-if="warnings.length" class="warning-banner">
          <div v-for="(w, idx) in warnings" :key="idx" class="warning-item">
              <strong>WARNING:</strong> {{ w.message }}
              <div v-if="w.invoices && w.invoices.length" class="warning-invoices">
                  Affected invoices: {{ w.invoices.join(', ') }}
              </div>
          </div>
      </div>

      <!-- Nav bar -->
      <div class="nav-bar">

        <div v-if="!update_list || !update_list.length">
                <div class="loader"></div>
        </div>
        <div v-else>
                <div class="buttons-area">
                    <router-link :to="'/'">
                        <button style="background-color: #49bf47 ;cursor: pointer;">ADD NEW Bank File</button>
                    </router-link>
                    <router-link :to="'/upload_remittance'">
                        <button style="background-color: #49bf47 ;cursor: pointer;">ADD NEW Remit PDF</button>
                    </router-link>
                </div>
                <table >
                    <!-- Invoice	Invoice ID	Date	AR Posting	Status  -->
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="25%" />
                    <col width="20%" />
                    <thead>
                        <tr>
                            <th>Invoice</th>
                            <th>Invoice ID</th>
                            <th>Date</th>
                            <th>AR Posting</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="element in update_list" v-bind:key="element.id">
                            <td>{{ element.INV }}</td>
                            <td v-if="element.updateInfo=='Updated'" style="color: green">{{ element.id }}</td>
                            <td v-else-if="element.updateInfo=='Not Updated (Already Paid)'" style="color: #3498db">{{ element.id }}</td>
                            <td v-else style="color: red">{{ element.id }}</td>

                            <td v-if="element.updateInfo=='Updated'" style="color: green">{{ element.paymentDate }}</td>
                            <td v-else-if="element.updateInfo=='Not Updated (Already Paid)'" style="color: #3498db">{{ element.paymentDate }}</td>
                            <td v-else style = "color: red">{{ element.paymentDate }}</td>

                            <td v-if="element.updateInfo=='Updated'" style="color: green">{{ element.arPosting }}</td>
                            <td v-else-if="element.updateInfo=='Not Updated (Already Paid)'" style="color: #3498db">{{ element.arPosting }}</td>
                            <td v-else style = "color: red">{{ element.arPosting }}</td>

                            <td v-if="element.updateInfo=='Updated'" style="color: green">{{ element.updateInfo }}</td>
                            <td v-else-if="element.updateInfo=='Not Updated (Already Paid)'" style="color: #3498db">{{ element.updateInfo }}</td>
                            <td v-else style = "color: red">{{ element.updateInfo }}</td>
                        </tr>
                    </tbody>
                </table>
        </div>

      </div>
  </div>
</template>

<script>
  import api from '../services/api';

  export default {
    data () {
      return {
        status: {},
        update_list: [],
        warnings: [],
        resultLoaded: false,
      }
    },
    methods: {
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        async getResult() {
            while (!this.resultLoaded) {
                try {
                    let response = await api.get('/get_complete');
                    console.log('RESPONSE COMPLETE: ');
                    console.log(response['data']);
                    let data = response['data'];
                    if (response.status == 200 && data) {
                        // Handle both new format (object with update_list + warnings)
                        // and legacy format (plain array)
                        if (Array.isArray(data)) {
                            // Legacy format: response is a plain array
                            if (data.length > 0) {
                                this.update_list = data;
                                this.warnings = [];
                                this.resultLoaded = true;
                            }
                        } else if (data.update_list && data.update_list.length > 0) {
                            // New format: object with update_list and warnings
                            this.update_list = data.update_list;
                            this.warnings = data.warnings ?? [];
                            this.resultLoaded = true;
                        }
                        if (this.resultLoaded) {
                            this.status = data;
                            console.log('THIS UPDATE:');
                            console.log(this.update_list);
                            if (this.warnings.length) {
                                console.log('WARNINGS:', this.warnings);
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
                await this.sleep(2000)
            }
        }
    },
    mounted() {
      this.getResult()
    },
    name: 'CompletePage',
  }
</script>

<style scoped>
    h3, .p-h3 {
        text-align: left;
    }
    .nav-bar {
        width: 95%;
        margin: 0 auto;
        padding: 16px 32px;
        background: rgb(219, 227, 230);
        border: 0;
        border-radius: 4px;
    }

    .info {
        position: absolute;
        left: 8px;
        top: 8px;
        font-weight: bold;
        color: rgb(128, 128, 128);
        display: inline-block;
    }

    .warning-banner {
        width: 95%;
        margin: 10px auto;
        padding: 12px 20px;
        background-color: #fff3cd;
        border: 1px solid #ffc107;
        border-left: 4px solid #ff9800;
        border-radius: 4px;
        text-align: left;
        color: #856404;
        font-size: 0.95em;
    }

    .warning-item {
        margin-bottom: 6px;
    }

    .warning-item:last-child {
        margin-bottom: 0;
    }

    .warning-invoices {
        margin-top: 4px;
        font-size: 0.85em;
        color: #6c5700;
        word-break: break-word;
    }

    .router-link {
        text-decoration: none;
    }

    a {
        text-decoration: none;
    }

    .progress-area {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .progress-area-block {
        display: flex;
        align-items: center;
    }

    .progress-area-block-label {
        padding-right: 15px;
        font-weight: bold;
    }

    button {
        line-height: 38px;
        margin: 10px;
        text-align: center;
        padding: 0 30px;
        vertical-align: middle;
        font-size: .875rem;
        color: #fff;
        background-color: #1e87f0;
        border: 1px solid transparent;
        font-weight: bold;
        border-radius: 4px;
    }

    .buttons-area {
        text-align: right;
    }

    button:disabled {
        background-color: #cccccc;
        color: #707070;
    }

    .loader {
        border: 16px solid #f3f3f3;
        border-radius: 50%;
        border-top: 16px solid blue;
        border-bottom: 16px solid blue;
        width: 120px;
        height: 120px;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;
    }

    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }


    table {
        border-collapse: collapse;
        margin: 25px auto;
        font-size: 0.9em;
        font-family: sans-serif;
        width: 100%;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
        table-layout:fixed;
    }

    th, td {
        padding: 12px 15px;
        word-wrap: break-word;
    }

    thead tr {
        background-color: #1e87f0;
        color: #ffffff;
        text-align: center;
        padding: 25px;
    }

    .loader {
        border: 8px solid #f3f3f3; /* Light grey */
        border-top: 8px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        justify-content: center;
        display: inline-block;
    }

    .buttons-area {
        justify-content: right;
        align-items: right;
        width: 100%;
        display: flex;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>
